<template>
  <div class="library-show-view">
    <div class="content">
      <breadcrumbs :breadcrumbs="libraryBreadcrumbs" />
      <component
        :is="componentName"
        :asset="libraryAsset"
        :attachment="libraryAsset"
        :content-source="contentSource"
        :display-attachment="displayAttachment"
        :show-asset-recommendations="true"
        :total-views="totalViews"
      />
    </div>
  </div>
</template>

<script>
import AttachmentPage from '@/components/attachments/page';
import Breadcrumbs from '@/components/singletons/breadcrumbs';
import LibraryTopic from '@/components/library/topic';
import TagList from '@/components/ui/tagList';

import AssetPageMixin from '@/mixins/asset-page';
import GlobalMixin from '@/mixins/global';
import LibraryMixin from '@/mixins/library';

export default {
  name: 'LibraryShow',
  components: { AttachmentPage, Breadcrumbs, LibraryTopic, TagList },
  mixins: [AssetPageMixin, GlobalMixin, LibraryMixin],
  computed: {
    assetId() {
      return this.$route.params?.assetId;
    },
    assetType() {
      const assetType = this.$route.params?.assetType;
      if (assetType) {
        return assetType[0].toUpperCase() + assetType.slice(1);
      }
    },
    assetTags() {
      return this.libraryAsset?.tags || [];
    },
    componentName() {
      if (this.assetType === 'Attachment') {
        return 'attachment-page';
      } else {
        return `Library${this.assetType[0].toUpperCase() + this.assetType.slice(1)}`;
      }
    },
    libraryAsset() {
      if (this.assetType && this.assetId) {
        return this.assetByAssetType(this.assetType, this.assetId);
      }
    },
  },
  created() {
    if (this.assetType === 'Attachment') {
      this.$store.dispatch('attachments/fetch', { ids: [this.assetId] });
    }
  },
};
</script>

<style lang="scss" scoped>
.library-show-view {
  padding-top: 0 !important;

  .content {
    max-width: rem-calc(1024);
    margin: 0 auto;

    :deep(.breadcrumbs-component-container) {
      padding: 0;
    }
  }

  .related-tags {
    margin: rem-calc(32) 0;
  }
}
</style>
